import $http from '../../../axios-instance';
import Swal from 'sweetalert2';

export async function listarTipoListaChequeo({state, commit}, requestParameters = {params: state.filtro}) {

    commit('dashboard/load', true, {root: true});

    await $http.get('adm_general/tipo-lista-chequeo', requestParameters)
        .then((response) => {
            commit('setListarTipoListaChequeo', response.data.data);
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });

    commit('dashboard/load', false, {root: true});
}

export async function crearTipoListaChequeo({commit, state, dispatch}) {

    commit('dashboard/load', true, {root: true});

    dispatch('construirItems');

    await $http.post('adm_general/tipo-lista-chequeo/crear', state.selectedTipoListaChequeo)
        .then((response) => {

            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: true,
                timer: 5000
            });
            commit('resetSelectedTipoListaChequeo');
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });

        });

    commit('dashboard/load', false, {root: true});
}

export async function mostrarTipoListaChequeo({commit}, id) {

    commit('dashboard/load', true, {root: true});

    await $http.get(`adm_general/tipo-lista-chequeo/mostrar/${id}`)
        .then(async (response) => {
            commit('setTipoListaChequeo', response.data.data);
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });

    commit('dashboard/load', false, {root: true});
}

export async function actualizarTipoListaChequeo({commit, state, dispatch}) {

    commit('dashboard/load', true, {root: true});

    dispatch('construirItems');

    await $http.put(`adm_general/tipo-lista-chequeo/editar/${state.selectedTipoListaChequeo.id}`, state.selectedTipoListaChequeo)
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: true,
                timer: 5000
            });
            dispatch('mostrarTipoListaChequeo', state.selectedTipoListaChequeo.id);

        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });

    commit('dashboard/load', false, {root: true});
}

export async function construirItems({commit, state, dispatch}) {
    let items = [];

    state.tiposSeguimientoSeleccionados.map(ts => {
        ts.items.map(i => {
            if (i.seleccionado) {
                const item = {
                    id_tipo_lista_chequeo: state.selectedTipoListaChequeo.id,
                    id_tipo_seguimiento: ts.id,
                    id_item: i.id
                };

                items.push(item);
            }
        });
    });

    commit('establecerItemsLista', items);
}

export async function desactivarTipoListaChequeo({commit, state, dispatch}, id) {

    await Swal.fire({
        title: 'Cambiar estado',
        text: '¿Está seguro de cambiar el estado del tipo de lista de chequeo?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Si, cambiar'
    }).then(async (result) => {
        if (result.value) {
            await $http.put(`adm_general/tipo-lista-chequeo/inactivar/${id}`)
                .then(async (response) => {
                    await Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Muy bien!',
                        text: response.data.message,
                        showConfirmButton: true,
                        timer: 5000
                    });
                    await dispatch('listarTipoListaChequeo');
                }).catch((error) => {
                    Swal.fire({
                        position: 'center',
                        icon: 'error',
                        title: error.message + '<br> ' + error.errors,
                        showConfirmButton: true,
                        timer: 5000
                    });
                });
        }
    });
}

export async function obtenerItems({commit, state}) {

    commit('dashboard/load', true, {root: true});

    const parametros = {
        params: {
            tipos_seguimiento: state.selectedTipoListaChequeo.tipo_seguimiento
        }
    };

    await $http.get('adm_general/item', parametros)
        .then(async (response) => {
            commit('establecerItems', response.data.data);
        }).catch(async (error) => {
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: true,
                timer: 3000
            });
        });

    commit('dashboard/load', false, {root: true});
}

export async function listaTipoSeguimiento({commit, state}) {



        const parametros = {
            params: {
                paginate: false
            }
        };

        await $http.get('adm_general/tipo-seguimiento', parametros)
            .then((response) => {
                commit('setListarTipoSeguimiento', response.data.data);
            })
            .catch((error) => {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: error.message + '<br> ' + error.errors,
                    showConfirmButton: true,
                    timer: 5000
                });
            });

}

// filtro de paginacion
export function setPagePagination({commit, dispatch}, page) {
    commit('setPage', parseInt(page));
    dispatch('listarTipoListaChequeo');
}

/**
 * Método para obtener las empresas registradas.
 *
 * @export
 * @param {*} {dispatch, commit, state}
 */
export async function obtenerEmpresas({dispatch, commit, state}) {
    commit('dashboard/load', true, {root: true});
    await $http.get('/empresas/lista', {params: {nombre: ''}})
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setEmpresas', response.data.data);
        })
        .catch(() => {
            commit('dashboard/load', false, {root: true});
            console.warn('No se encontraron empresas con el nombre especificado');
        });
}

export async function asignarEmpresa({dispatch, commit, state}, id_empresa) {

    commit('dashboard/load', true, {root: true});

    await $http.post(`adm_general/tipo-lista-chequeo/asignar/${state.selectedTipoListaChequeo.id}/${id_empresa}`)
        .then(async (response) => {
            commit('asignarEmpresa', id_empresa);
            commit('dashboard/load', false, {root: true});
        })
        .catch((e) => {
            console.log(e);
            commit('dashboard/load', false, {root: true});
        });
}

export async function desasignarEmpresa({dispatch, commit, state}, id_empresa) {

    commit('dashboard/load', true, {root: true});

    await $http.post(`adm_general/tipo-lista-chequeo/desasignar/${state.selectedTipoListaChequeo.id}/${id_empresa}`)
        .then(async (response) => {
            commit('desasignarEmpresa', id_empresa);
            commit('dashboard/load', false, {root: true});
        })
        .catch((e) => {
            console.log(e);
            commit('dashboard/load', false, {root: true});
        });
}
